import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
import { ClientIpService } from '../services/client-ip.service';

// Stamps every outgoing request with the browser's own public ip (see
// ClientIpService) as a header, so the backend can prefer it over its own
// x-forwarded-for/remoteAddress guess (see getRequestIp in
// otc_admin_backend/controller/adminuserAlController.js) without every
// caller having to fetch and pass it individually.
@Injectable()
export class ClientIpInterceptor implements HttpInterceptor {

  constructor(private clientIpService: ClientIpService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.clientIpService.getClientIp().pipe(
      switchMap((clientIp) => {
        const cloned = clientIp
          ? req.clone({ headers: req.headers.set('X-Client-Ip', clientIp) })
          : req;
        return next.handle(cloned);
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/client-ip.interceptor.ts